// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--1nkyQ","service":"style-module--service--1wBpr","services":"style-module--services--1LoiK"};